import { Action, createReducer, on } from '@ngrx/store';
import { initialEligibilityEngineServiceState } from './eligibility-engine-service.state';
import {
  initializeEligibilityEngineServiceState,
  loadEligibilityEngineRules,
  loadEligibilityEngineRulesSuccess,
  loadEligibilityEngineRulesFailure,
} from './eligibility-engine-service.actions';

const featureReducer = createReducer(
  initialEligibilityEngineServiceState,
  on(initializeEligibilityEngineServiceState, (state) => ({ ...state, ...initialEligibilityEngineServiceState })),
  on(loadEligibilityEngineRules, (state) => ({ ...state, loading: true, error: null })),
  on(loadEligibilityEngineRulesSuccess, (state, { rules }) => ({
    ...state,
    rules,
    loading: false,
    error: null,
  })),
  on(loadEligibilityEngineRulesFailure, (state, { error }) => ({
    ...state,
    rules: null,
    loading: false,
    error,
  }))
);

export function eligibilityEngineServiceReducer(state = initialEligibilityEngineServiceState, action: Action) {
  return featureReducer(state, action);
}
